// extracted by mini-css-extract-plugin
export default {"loadingWrapper":"App_loadingWrapper__4NMph","spinner":"App_spinner__2qIgM","spin":"App_spin__kjE+S"};